import { useRecoilValue } from 'recoil';

import { inventoryAtom } from 'src/app/state/inventory';

import type { GridColumn } from 'src/app/components/lib/table/data-grid';
import type { SmartTagPackagePreview } from 'src/app/queries/inventory/smart-tags/preview-packages';

export function useColumns(): GridColumn<SmartTagPackagePreview>[] {
  const { brands, productCategories } = useRecoilValue(inventoryAtom);

  return [
    { field: 'ProductName', headerName: 'Product name' },
    { field: 'SerialNumber', headerName: 'Serial number' },
    { field: 'PackageId', headerName: 'Package ID' },
    {
      field: 'ProductCategory',
      headerName: 'Category',
      renderCell: (params) => {
        const category = productCategories?.find((c) => c.ProductCategoryId === Number(params.value));
        return category?.ProductCategory ?? '';
      },
    },
    {
      field: 'ProductBrand',
      headerName: 'Brand',
      renderCell: (params) => {
        const brand = brands?.find((b) => b.BrandId === Number(params.value));
        return brand?.BrandName ?? '';
      },
    },
  ];
}
